import React from 'react';

const ReferenceMaterialsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <h1 className="text-xl font-bold text-gray-900">HSK Learning App</h1>
            </div>
          </div>
        </div>
      </header>
      <main>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Reference Materials</h2>
            <p className="text-lg text-gray-600 mb-8">
              Essential HSK 1-3 learning resources for English speakers:
            </p>
            
            <div className="grid grid-cols-1 gap-8">
              {/* Common Chinese Characters Section */}
              <div className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Common Chinese Characters (HSK 1-3)</h3>
                <p className="text-gray-600 mb-6">Essential Chinese characters with pinyin, English definitions, and example sentences, organized by lesson.</p>
                
                <div className="space-y-6">
                  {/* Lesson 1 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 1</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>一 (yī) - One</span>
                        <span className="text-sm text-gray-500">Example: 我有一本书。 (I have a book.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>二 (èr) - Two</span>
                        <span className="text-sm text-gray-500">Example: 我有两个苹果。 (I have two apples.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>三 (sān) - Three</span>
                        <span className="text-sm text-gray-500">Example: 三个人。 (Three people.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>十 (shí) - Ten</span>
                        <span className="text-sm text-gray-500">Example: 现在十点了。 (It's ten o'clock now.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>八 (bā) - Eight</span>
                        <span className="text-sm text-gray-500">Example: 我八岁了。 (I'm eight years old.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>六 (liù) - Six</span>
                        <span className="text-sm text-gray-500">Example: 六点见面。 (Meet at six o'clock.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 2 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 2</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>口 (kǒu) - Mouth</span>
                        <span className="text-sm text-gray-500">Example: 他的口很大。 (His mouth is big.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>见 (jiàn) - See</span>
                        <span className="text-sm text-gray-500">Example: 明天见。 (See you tomorrow.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>山 (shān) - Mountain</span>
                        <span className="text-sm text-gray-500">Example: 那座山很高。 (That mountain is very high.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>小 (xiǎo) - Small</span>
                        <span className="text-sm text-gray-500">Example: 小房子。 (Small house.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>不 (bù) - No, not</span>
                        <span className="text-sm text-gray-500">Example: 我不知道。 (I don't know.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 3 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 3</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>月 (yuè) - Moon, month</span>
                        <span className="text-sm text-gray-500">Example: 一个月。 (One month.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>心 (xīn) - Heart</span>
                        <span className="text-sm text-gray-500">Example: 我的心。 (My heart.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>中 (zhōng) - Middle, China</span>
                        <span className="text-sm text-gray-500">Example: 中国。 (China.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>人 (rén) - Person</span>
                        <span className="text-sm text-gray-500">Example: 好人。 (Good person.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 4 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 4</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>七 (qī) - Seven</span>
                        <span className="text-sm text-gray-500">Example: 七天。 (Seven days.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>儿 (ér) - Child</span>
                        <span className="text-sm text-gray-500">Example: 儿子。 (Son.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>几 (jǐ) - Several</span>
                        <span className="text-sm text-gray-500">Example: 几个苹果。 (Several apples.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>九 (jiǔ) - Nine</span>
                        <span className="text-sm text-gray-500">Example: 九岁。 (Nine years old.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 5 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 5</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>水 (shuǐ) - Water</span>
                        <span className="text-sm text-gray-500">Example: 喝水。 (Drink water.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>女 (nǚ) - Woman</span>
                        <span className="text-sm text-gray-500">Example: 女人。 (Woman.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>了 (le) - Particle</span>
                        <span className="text-sm text-gray-500">Example: 我吃了。 (I ate.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>大 (dà) - Big</span>
                        <span className="text-sm text-gray-500">Example: 大房子。 (Big house.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 6 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 6</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>东 (dōng) - East</span>
                        <span className="text-sm text-gray-500">Example: 东方。 (East.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>我 (wǒ) - I</span>
                        <span className="text-sm text-gray-500">Example: 我是学生。 (I'm a student.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>西 (xī) - West</span>
                        <span className="text-sm text-gray-500">Example: 西方。 (West.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 7 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 7</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>四 (sì) - Four</span>
                        <span className="text-sm text-gray-500">Example: 四个。 (Four.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>五 (wǔ) - Five</span>
                        <span className="text-sm text-gray-500">Example: 五岁。 (Five years old.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>书 (shū) - Book</span>
                        <span className="text-sm text-gray-500">Example: 一本书。 (A book.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 8 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 8</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>少 (shǎo) - Few</span>
                        <span className="text-sm text-gray-500">Example: 很少。 (Very few.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>个 (gè) - Measure word</span>
                        <span className="text-sm text-gray-500">Example: 一个人。 (A person.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 9 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 9</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>在 (zài) - At, in</span>
                        <span className="text-sm text-gray-500">Example: 我在家。 (I'm at home.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>子 (zǐ) - Child</span>
                        <span className="text-sm text-gray-500">Example: 孩子。 (Child.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>工 (gōng) - Work</span>
                        <span className="text-sm text-gray-500">Example: 工作。 (Work.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 10 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 10</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>上 (shàng) - Up</span>
                        <span className="text-sm text-gray-500">Example: 上面。 (Above.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>下 (xià) - Down</span>
                        <span className="text-sm text-gray-500">Example: 下面。 (Below.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>本 (běn) - Book, origin</span>
                        <span className="text-sm text-gray-500">Example: 一本书。 (A book.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>末 (mò) - End</span>
                        <span className="text-sm text-gray-500">Example: 期末。 (End of term.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 11 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 11</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>午 (wǔ) - Noon</span>
                        <span className="text-sm text-gray-500">Example: 中午。 (Noon.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>电 (diàn) - Electricity</span>
                        <span className="text-sm text-gray-500">Example: 电话。 (Telephone.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 12 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 12</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>天 (tiān) - Sky, day</span>
                        <span className="text-sm text-gray-500">Example: 明天。 (Tomorrow.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>气 (qì) - Air, weather</span>
                        <span className="text-sm text-gray-500">Example: 天气。 (Weather.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>雨 (yǔ) - Rain</span>
                        <span className="text-sm text-gray-500">Example: 下雨。 (Rain.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 13 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 13</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>日 (rì) - Sun, day</span>
                        <span className="text-sm text-gray-500">Example: 日子。 (Day.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>目 (mù) - Eye</span>
                        <span className="text-sm text-gray-500">Example: 目光。 (Sight.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>习 (xí) - Study</span>
                        <span className="text-sm text-gray-500">Example: 学习。 (Study.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 14 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 14</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>开 (kāi) - Open</span>
                        <span className="text-sm text-gray-500">Example: 开门。 (Open the door.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>车 (chē) - Car</span>
                        <span className="text-sm text-gray-500">Example: 汽车。 (Car.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>回 (huí) - Return</span>
                        <span className="text-sm text-gray-500">Example: 回家。 (Go home.)</span>
                      </li>
                    </ul>
                  </div>
                  
                  {/* Lesson 15 */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-3">Lesson 15</h4>
                    <ul className="text-left space-y-2">
                      <li className="flex flex-col">
                        <span>年 (nián) - Year</span>
                        <span className="text-sm text-gray-500">Example: 新年。 (New Year.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>出 (chū) - Go out</span>
                        <span className="text-sm text-gray-500">Example: 出去。 (Go out.)</span>
                      </li>
                      <li className="flex flex-col">
                        <span>飞 (fēi) - Fly</span>
                        <span className="text-sm text-gray-500">Example: 飞机。 (Airplane.)</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ReferenceMaterialsPage;